import React from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ModalHeader, ModalRow, ModalRowValue, ModalSection, ModalSectionTitle, ScrollableContent } from "../Styles/InputStyles";
import ModalProfileHeader from "../Common/ModalProfileHeader";
import { capitalizeFirstLetter } from "../../helpers";

const ViewAgreementDetails = ({ setIsViewAgreement, selectedData }) => {
    const onClose = () => {
        setIsViewAgreement(false);
    };

    return (
        <Container>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Agreement Details</h1>
                <button onClick={onClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <ModalProfileHeader
                title="View Details"
                name={capitalizeFirstLetter(selectedData?.tenantName)}
                subtitle={`#${selectedData?.tenantMobile}`}
                amountLabel={"Rent"}
                amount={selectedData?.rent || 0}
                image={selectedData?.profilePicture}
                onClose={onClose}
                showCurrency={true}
            />

            <Content>
                <ScrollableContent>
                    <Wrapper>
                        {/* CURRENT AGREEMENT DETAILS */}
                        <BtnWrapper>
                            <ModalSectionTitle>New Agreement</ModalSectionTitle>
                        </BtnWrapper>

                        <ModalSection>
                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>Property</LabelShow>
                                    <ModalRowValue>{selectedData?.propName}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Agreement Period</LabelShow>
                                    <ModalRowValue>{selectedData?.agreementPeriod} Months</ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>Rent</LabelShow>
                                    <ModalRowValue>₹{selectedData?.rent}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Security</LabelShow>
                                    <ModalRowValue>₹{selectedData?.security}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>Agreement Start Date</LabelShow>
                                    <ModalRowValue>
                                        {selectedData?.agreementStartDate
                                            ? moment(selectedData?.agreementStartDate).format(
                                                "DD, MMM YY"
                                            )
                                            : "-"}
                                    </ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Agreement End Date</LabelShow>
                                    <ModalRowValue>
                                        {selectedData?.agreementStartDate &&
                                            selectedData?.agreementPeriod
                                            ? moment(selectedData?.agreementStartDate)
                                                .add(selectedData?.agreementPeriod, "months")
                                                .format("DD, MMM YY")
                                            : "-"}
                                    </ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>Lock-In Period</LabelShow>
                                    <ModalRowValue>{selectedData?.lockInPeriod} Months</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Notice Period</LabelShow>
                                    <ModalRowValue>{selectedData?.noticePeriod} Months</ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>Done By</LabelShow>
                                    <ModalRowValue>{selectedData?.doneByName || "-"}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Renewed Date</LabelShow>
                                    <ModalRowValue>
                                        {selectedData?.createdAt
                                            ? moment(selectedData?.createdAt).format(
                                                "DD, MMM YY hh:mm A"
                                            )
                                            : "-"}
                                    </ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                        </ModalSection>

                        {/* PREVIOUS AGREEMENT DETAILS */}
                        <BtnWrapper>
                            <ModalSectionTitle>Previous Agreement</ModalSectionTitle>
                        </BtnWrapper>

                        <ModalSection>
                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>Rent</LabelShow>
                                    <ModalRowValue>₹{selectedData?.prevRent ?? "-"}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Security</LabelShow>
                                    <ModalRowValue>₹{selectedData?.prevSecurity ?? "-"}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>Agreement Start Date</LabelShow>
                                    <ModalRowValue>
                                        {selectedData?.prevAgreementStartDate
                                            ? moment(selectedData?.prevAgreementStartDate).format(
                                                "DD, MMM YY"
                                            )
                                            : "-"}
                                    </ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Agreement End Date</LabelShow>
                                    <ModalRowValue>
                                        {selectedData?.prevAgreementStartDate &&
                                            selectedData?.prevAgreementPeriod
                                            ? moment(selectedData?.prevAgreementStartDate)
                                                .add(selectedData?.prevAgreementPeriod, "months")
                                                .format("DD, MMM YY")
                                            : "-"}
                                    </ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>Lock-In Period</LabelShow>
                                    <ModalRowValue>{selectedData?.prevLockInPeriod} Months</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Notice Period</LabelShow>
                                    <ModalRowValue>{selectedData?.prevNoticePeriod} Months</ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>Agreement Period</LabelShow>
                                    <ModalRowValue>{selectedData?.prevAgreementPeriod} Months</ModalRowValue>
                                </FlexCol>

                            </ModalRow>
                        </ModalSection>
                    </Wrapper>
                </ScrollableContent>
            </Content>
        </Container>
    );
};

/* Styled Components */
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Wrapper = tw.div`grid gap-2 my-0`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5 flex-1`;
const LabelShow = tw.label`text-sm text-gray-400 font-normal`;
export default ViewAgreementDetails;